export enum PermissionLevelEnum {
  NONE = 'NONE',
  PREVIEW = 'PREVIEW',
  READ = 'READ',
  WRITE = 'WRITE'
}
